/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getFilterPresets } from "api/services/user";
import { FilterPreset } from "types/Common";
import { userQueryKeys } from "./userQueryKeys";

export function useGetFilterPresets<T = FilterPreset[] | {}>(options: UseQueryOptions<T>) {
  return useQuery<T>({
    queryKey: userQueryKeys.userFilterPresets,
    queryFn: () => getFilterPresets().then((res) => res.data),
    ...options,
  });
}
